export class CascadeItem {
  public val?: string | null;
  public idx?: number;
  public children?: Map<string, CascadeItem> = new Map();

  // Function to create a root-level Map from JSON
  public static createMapFromJson(jsonString: string): Map<string, CascadeItem> {

    const jsonData = JSON.parse(jsonString); 
    const rootMap = new Map<string, CascadeItem>();

    jsonData.forEach((item: any) => {
      const cascadeItem = CascadeItem.createItemFromJson(item);
      if (cascadeItem.val) {
        rootMap.set(cascadeItem.val, cascadeItem);
      }
    });

    return rootMap;
  }

  // Function to recursively create a `CascadeItem` from a JSON object
  protected static createItemFromJson(jsonItem: any): CascadeItem {

    if (!jsonItem) {
      return new CascadeItem();
    }

    if (typeof jsonItem !== 'object') {
      throw new Error('Invalid JSON object');
    }

    if (Array.isArray(jsonItem)) {
      throw new Error('JSON object should not be an array');
    }

    const root = new CascadeItem();
    root.val = jsonItem.val || null;
    root.idx = jsonItem.idx || null;

    if (jsonItem.children && Array.isArray(jsonItem.children)) {

      root.children = new Map();

      jsonItem.children.forEach((child: any) => {
        const childItem = CascadeItem.createItemFromJson(child);
        if (childItem.val) {
          root.children!.set(childItem.val, childItem);
        }
      });
    }

    return root;
  }
}

